(function () {
  "use strict";
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAlumniStories);
  } else {
    initAlumniStories();
  }
  function initAlumniStories() {
    const container = document.getElementById("alumni-scroll-container");
    if (!container) return;
    const storyCount = parseInt(container.dataset.storyCount || "0", 10);
    const isDraggable = storyCount > 1;
    let isDown = false;
    let startX;
    let scrollLeft;
    function setEqualHeights() {
      const slides = container.children;
      if (!slides.length) return;
      let maxHeight = 0;
      Array.from(slides).forEach((slide) => {
        const slideContent = slide.querySelector(
          ".flex.flex-col.sm\\:flex-row",
        );
        if (slideContent) {
          slideContent.style.height = "auto";
          maxHeight = Math.max(maxHeight, slideContent.offsetHeight);
        }
      });
      if (maxHeight > 0) {
        Array.from(slides).forEach((slide) => {
          const slideContent = slide.querySelector(
            ".flex.flex-col.sm\\:flex-row",
          );
          if (slideContent) {
            slideContent.style.height = maxHeight + "px";
          }
        });
      }
    }
    function updateNavButtons() {
      if (storyCount <= 1) return;
      const prevBtn = document.getElementById("prev-button");
      const nextBtn = document.getElementById("next-button");
      if (!prevBtn || !nextBtn) return;
      const scrollLeft = container.scrollLeft;
      const maxScroll = container.scrollWidth - container.offsetWidth;
      const tolerance = 10;
      prevBtn.disabled = scrollLeft <= tolerance;
      nextBtn.disabled = Math.abs(scrollLeft - maxScroll) <= tolerance;
    }
    window.moveSlide = function (dir) {
      if (storyCount <= 1 || !container) return;
      const containerWidth = container.offsetWidth;
      const scrollPosition = container.scrollLeft;
      const maxScroll = container.scrollWidth - containerWidth;
      if (dir === "next") {
        if (scrollPosition >= maxScroll - 10) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollTo({
            left: Math.min(scrollPosition + containerWidth, maxScroll),
            behavior: "smooth",
          });
        }
      } else {
        if (scrollPosition <= 10) {
          container.scrollTo({ left: maxScroll, behavior: "smooth" });
        } else {
          container.scrollTo({
            left: Math.max(scrollPosition - containerWidth, 0),
            behavior: "smooth",
          });
        }
      }
      setTimeout(updateNavButtons, 300);
    };

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    if (isDraggable) {
      container.addEventListener("mousedown", (e) => {
        isDown = true;
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });
      container.addEventListener("mouseleave", () => {
        isDown = false;
      });
      container.addEventListener("mouseup", () => {
        isDown = false;
      });
      container.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 1.5;
        container.scrollLeft = scrollLeft - walk;
      });
      container.addEventListener("dragstart", (e) => e.preventDefault());
    }
    setTimeout(() => {
      setEqualHeights();
      updateNavButtons();
    }, 200);
    container.addEventListener("scroll", updateNavButtons);
    const debouncedResize = debounce(() => {
      setEqualHeights();
      updateNavButtons();
    }, 250);
    window.addEventListener("resize", debouncedResize);
    const images = container.querySelectorAll("img");
    if (images.length > 0) {
      images.forEach((img) => {
        if (img.complete) {
          setEqualHeights();
        } else {
          img.addEventListener("load", setEqualHeights);
        }
      });
    }
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(
        debounce(() => {
          setEqualHeights();
          updateNavButtons();
        }, 100),
      );
      observer.observe(container);
      Array.from(container.children).forEach((slide) => {
        observer.observe(slide);
      });
    }
  }
})();
